import React from 'react';
import { Navigate } from 'react-router-dom';
import { checkRoot } from '@app/services/localStorage.service';

interface RequireAdminProps {
  children?: React.ReactNode;
  /** Where to send non-admin users (default: calib dashboard). */
  redirectTo?: string;
}

const RequireAdmin: React.FC<RequireAdminProps> = ({ children, redirectTo = '/calib/dashboard' }) => {
  return checkRoot() ? <>{children}</> : <Navigate to={redirectTo} replace />;
};

export default RequireAdmin;
